import { axios } from '@/api/common';


export default {
    sendResetPasswordEmail(emailParam) {
        return axios.post('/Member/SendResetPasswordEmail', { email: emailParam }).then((response) => {
            if (response.status == 200) {
                return {
                    isError: false,
                    data: response.data
                };
            }
        }).catch((error) => {
            return {
                isError: true,
                errorDecription: error.response.data.error_description
            }
        });
    },
    resetPassword(memberCode, newPassword) {
        return axios.post('/Member/ResetPassword', {
            memberCode,
            newPassword
        }).then((response) => {
            return {
                isError: false,
                data: response.data
            };
        }).catch((error) => {
            return {
                isError: true,
                errorDecription: error.response?.data?.error_description
            };
        });
    },
    IsMailUnique(email) {
        return axios.get('/Member/IsMailUnique?Email=' + email).then((response) => {
            if (response.status == 200) {
                return {
                    isError: false,
                    data: response.data
                };
            }
        }).catch((error) => {
            return {
                isError: true,
                errorDecription: error.response.data.error_description
            }
        });
    },
    IsMailUnique_ForUpdate(memberId, email) {
        return axios.get('/Member/IsMailUnique_ForUpdate?MemberId=' + memberId + '&Email=' + email).then((response) => {
            if (response.status == 200) {
                return {
                    isError: false,
                    data: response.data
                };
            }
        }).catch((error) => {
            return {
                isError: true,
                errorDecription: error.response.data.error_description
            }
        });
    },
    IsPhoneNumberUnique(phone) {
        return axios.get('/Member/IsPhoneNumberUnique?Phone=' + phone).then((response) => {
            if (response.status == 200) {
                return {
                    isError: false,
                    data: response.data
                };
            }
        }).catch((error) => {
            return {
                isError: true,
                errorDecription: error.response.data.error_description
            }
        });
    },
    IsPhoneNumberUnique_ForUpdate(memberId, phone) {
        return axios.get('/Member/IsPhoneNumberUnique_ForUpdate?MemberId=' + memberId + '&Phone=' + phone).then((response) => {
            if (response.status == 200) {
                return {
                    isError: false,
                    data: response.data
                };
            }
        }).catch((error) => {
            return {
                isError: true,
                errorDecription: error.response.data.error_description
            }
        });
    },
    // Sign-in (docs/16-api-authorization.md): the e-mail and password as typed, in the body;
    // the answer is the member and the token. It replaced encryptLogin + a GET that carried
    // the encrypted pair in its URL. unauthorized: the pair did not match a member.
    login(email, password, rememberMe) {
        return axios.post('/Member/Login', { Email: email, Password: password, RememberMe: !!rememberMe }).then((response) => {
            return {
                isError: false,
                data: response.data
            };
        }).catch((error) => {
            return {
                isError: true,
                unauthorized: !!(error.response && error.response.status == 401),
                errorDecription: error.response && error.response.data ? error.response.data.error_description : ''
            }
        });
    },
    encryptMember(model) {
        return axios.post('/Member/EncryptMember', model).then((response) => {
            if (response.status == 200) {
                return {
                    isError: false,
                    data: response.data
                };
            }
        }).catch((error) => {
            return {
                isError: true,
                errorDecription: error.response.data.error_description
            }
        });
    },
    /**
     * The Turnstile token travels in a header rather than in the body: the body is the
     * encrypted member model, and the token is neither encrypted nor stored. The API
     * posts it to Cloudflare and rejects the registration with 403 if it does not check out.
     */
    addNewMember(member, turnstileToken) {
        var config = turnstileToken
            ? { headers: { 'CF-Turnstile-Response': turnstileToken } }
            : {};

        return axios.post('/Member/AddNewMember', member, config).then((response) => {
            if (response.status == 200) {
                return {
                    isError: false,
                    data: response.data
                };
            }
        }).catch((error) => {
            var response = error.response;
            return {
                isError: true,
                status: response ? response.status : 0,
                errorDecription: response && response.data ? response.data.error_description : undefined,
                // A 422 carries the CRM's own field errors, which is the only thing that can
                // tell the registrant which box to change. Without this they were dropped
                // here and the form could only say "please try again".
                errors: response && response.data ? response.data.errors : undefined
            }
        });
    },
    // The profile calls are the signed-in member's (the token); the API reads and writes that member only.
    // The member is the token's.
    updateMember(profile) {
        return axios.post('/Member/UpdateMember', { Profile: profile }).then((response) => {
            if (response.status == 200) {
                return {
                    isError: false,
                    data: response.data
                };
            }
        }).catch((error) => {
            return {
                isError: true,
                errorDecription: error.response.data.error_description
            }
        });
    },
    getMyProfile() {
        return axios.post('/Member/GetMyProfile').then((response) => {
            if (response.status == 200) {
                return {
                    isError: false,
                    data: response.data
                };
            }
        }).catch((error) => {
            return {
                isError: true,
                errorDecription: error.response.data.error_description
            }
        });
    },
    getCountries() {
        return axios.post('/Member/GetCountries').then((response) => {
            if (response.status == 200) {
                return {
                    isError: false,
                    data: response.data
                };
            }
        }).catch((error) => {
            return {
                isError: true,
                errorDecription: error.response.data.error_description
            }
        });
    },
    getCities(countryId) {
        return axios.get('/Member/GetCities?CountryId=' + countryId).then((response) => {
            if (response.status == 200) {
                return {
                    isError: false,
                    data: response.data
                };
            }
        }).catch((error) => {
            return {
                isError: true,
                errorDecription: error.response.data.error_description
            }
        });
    },
    getCommLanguages() {
        return axios.post('/Member/GetCommLanguages').then((response) => {
            if (response.status == 200) {
                return {
                    isError: false,
                    data: response.data
                };
            }
        }).catch((error) => {
            return {
                isError: true,
                errorDecription: error.response.data.error_description
            }
        });
    },
    SendUserListDownloadedMail(memberId) {
        return axios.post('/Member/SendUserListDownloadedMail?memberId=' + memberId).then((response) => {
            if (response.status == 200) {
                return {
                    isError: false,
                    data: response.data
                };
            }
        }).catch((error) => {
            return {
                isError: true,
                errorDecription: error.response.data.error_description
            }
        });
    },
}
